import { createContext, useContext } from 'react';

const defaultMsalContext = {
  msalInstance: null,
  msalUserAccount: null,
  authResult: null,
  authError: null,
  isLoading: false,
  isReady: false,
  changeMsalAccount: () => {},
  clearAuthResult: () => {},
  startLogin: async () => {},
  startLogout: async () => {},
};

export const MsalContext = createContext(defaultMsalContext);
export const useMsalDetails = () => useContext(MsalContext);
